export const UI_PREFERENCES_KEY = 'bolde-access-ui-preferences';
export const UI_PREFERENCES_EVENT = 'bolde-access-ui-preferences-change';

export const defaultUiPreferences = {
  primaryColor: '#003D79',
  mode: 'light',
  compact: false,
  animations: true,
  stickyHeader: true,
  contentWidth: 'fluid',
};

export function getUiPreferences() {
  if (typeof window === 'undefined') return defaultUiPreferences;
  try {
    const saved = JSON.parse(window.localStorage.getItem(UI_PREFERENCES_KEY) || '{}');
    return { ...defaultUiPreferences, ...saved };
  } catch (_) {
    return defaultUiPreferences;
  }
}

export function saveUiPreferences(next) {
  const preferences = { ...defaultUiPreferences, ...next };
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(UI_PREFERENCES_KEY, JSON.stringify(preferences));
    window.dispatchEvent(new CustomEvent(UI_PREFERENCES_EVENT, { detail: preferences }));
  }
  return preferences;
}

export function applyUiPreferences(preferences) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--app-primary', preferences.primaryColor);
  root.style.setProperty('--app-header-bg', preferences.primaryColor);
  root.dataset.theme = preferences.mode;
  root.dataset.animations = preferences.animations ? 'on' : 'off';
  root.dataset.stickyHeader = preferences.stickyHeader ? 'on' : 'off';
  root.dataset.contentWidth = preferences.contentWidth;
  root.dataset.compact = preferences.compact ? 'on' : 'off';
}
